import request from "@/utils/request";

export function list(data) {
	return request({
		url: '/app/service/list',
		method: 'get',
		data
	})
}

export function getDetail(data) {
	return request({
		url: '/app/news/detail',
		method: 'post',
		data
	})
}
export function markRead(data) {
	return request({
		url: '/app/news/read',
		method: 'post',
		data
	})
}
